/* eslint-disable no-shadow,camelcase,import/no-mutable-exports,no-console */
// TODO: 自动生成的 src/utils/config 禁用了部分 eslint, 请查看 scripts/genConfig.js

/**
 * 不要直接修改这个文件, 请修改 config/apiConfig 文件
 * Config - 全局统一配置
 * @date: 2018-6-20
 * @author: niujiaqing <njq.niu@hand-china.com>
 * @version: 0.0.1
 * @copyright Copyright (c) 2018, Hand
 */
// #region initConfig
var CLIENT_ID = "".concat(process.env.CLIENT_ID);
var API_HOST = "".concat(process.env.API_HOST);
var BPM_HOST = "".concat(process.env.BPM_HOST);
var WFP_EDITOR = "".concat(process.env.WFP_EDITOR);
var WEBSOCKET_URL = "".concat(process.env.WEBSOCKET_HOST);
var HISTORY_ENABLE = "".concat(process.env.HISTORY_ENABLE);
var SVG_ICON_ENABLE = "".concat(process.env.SVG_ICON_ENABLE);
var MULTIPLE_SKIN_ENABLE = "".concat(process.env.MULTIPLE_SKIN_ENABLE);
var TOP_MENU_LABELS = "".concat(process.env.TOP_MENU_LABELS);
var TOP_MENU_UNION_LABEL = "".concat(process.env.TOP_MENU_UNION_LABEL);
var ENV_SIGN = "".concat(process.env.ENV_SIGN);
var INVALID_TIME = "".concat(process.env.INVALID_TIME);
var CUSTOMIZE_ICON_NAME = "".concat(process.env.CUSTOMIZE_ICON_NAME);
var BAIDU_MAP_AK = "".concat(process.env.BAIDU_MAP_AK);
var MARKET_CLIENT_SDK_FLAG = "".concat(process.env.MARKET_CLIENT_SDK_FLAG);
var HZERO_PLATFORM = '/hpfm';
var HZERO_IAM = '/iam';
var HZERO_DTT = '/hdtt';
var HZERO_MSG = '/hmsg';
var HZERO_PTL = '/hptl';
var HZERO_WFL = '/hwfl';
var HZERO_DTW = '/hdtw';
var HZERO_HDTW = '/hdtw';
var HZERO_SDR = '/hsdr';
var HZERO_HSGP = '/hsgp';
var HZERO_HITF = '/hitf';
var HZERO_HFLE = '/hfle';
var HZERO_OAUTH = '/oauth';
var HZERO_ASGARD = '/hagd';
var HZERO_IMP = '/himp';
var HZERO_RPT = '/hrpt';
var HZERO_HCNF = '/hcnf';
var HZERO_HWFP = '/hwfp';
var HZERO_FILE = changeHZERO_FILE(API_HOST, HZERO_HFLE);
var HZERO_NLP = '/hnlp';
var HZERO_HPAY = '/hpay';
var HZERO_HEXL = '/hexl';
var HZERO_MNT = '/hmnt';
var HZERO_INVOICE = '/hivc';
var HZERO_IM = '/hims';
var HZERO_HTDO = '/htdo';
var HZERO_HKMS = '/hkms';
var HZERO_OCR = '/hocr';
var HZERO_CHG = '/hchg';
var HZERO_ADM = '/hadm';
var HZERO_DPM = '/hdpm';
var HZERO_HSRH = '/hsrh';
var HZERO_HMDE = '/hmde';
var HZERO_HRES = '/hres';
var HZERO_HLCD = '/hlcd';
var HZERO_HLOD = '/hlod';
var HZERO_HIOT = '/hiot';
var IIOT_IPFM = '/ipfm';
var HZERO_HEBK = '/hebk';
var HZERO_ALT = '/halt';
var HZERO_HEVT = '/hevt';
var HZERO_HDSC = '/hdsc';
var HZERO_HORC = '/horc';
var HZERO_HFNT = '/hfnt';
var HZERO_HPRT = '/hprt';
var HZERO_HWKF = '/hwkf';
var HZERO_HBAI = '/hbai';
var AUTH_HOST = changeAUTH_HOST(API_HOST, HZERO_OAUTH);
var LOGIN_URL = "".concat(process.env.LOGIN_URL || "".concat(AUTH_HOST, "/oauth/authorize?response_type=token&client_id=").concat(CLIENT_ID));
var LOGOUT_URL = "".concat(process.env.LOGOUT_URL || "".concat(AUTH_HOST, "/logout"));
var AUTH_SELF_URL = changeAUTH_SELF_URL(API_HOST, HZERO_IAM);
var VERSION_IS_OP = "".concat(process.env.PLATFORM_VERSION) === 'OP';
var BKT_PUBLIC = "".concat(process.env.BKT_PUBLIC || 'public');
var BKT_PLATFORM = "".concat(process.env.BKT_PLATFORM || 'hpfm');
var BKT_MSG = "".concat(process.env.BKT_MSG || 'hmsg');
var BKT_SDR = "".concat(process.env.BKT_SDR || 'hsdr');
var BKT_RPT = "".concat(process.env.BKT_RPT || 'hrpt');
var BKT_INVOICE = "".concat(process.env.BKT_INVOICE || 'hivc');
var BKT_OCR = "".concat(process.env.BKT_OCR || 'hocr');
var BKT_ADM = "".concat(process.env.BKT_ADM || 'hadm');
var BKT_HWFP = "".concat(process.env.BKT_HWFP || 'hwfp');
var BKT_HIMS = "".concat(process.env.BKT_HIMS || 'hims');
var BKT_HTDO = "".concat(process.env.BKT_HTDO || 'htdo');
var BKT_HITF = "".concat(process.env.BKT_HITF || 'hitf');
var BKT_HIMP = "".concat(process.env.BKT_HIMP || 'himp');
var BKT_HFILE = "".concat(process.env.BKT_HFILE || 'hfle');
var BKT_HIOT = "".concat(process.env.BKT_HIOT || 'hiot');
var BKT_HORC = "".concat(process.env.BKT_HORC || 'horc');
var BKT_HFNT = "".concat(process.env.BKT_HFNT || 'hfnt');
var BKT_HWKF = "".concat(process.env.BKT_HWKF || 'hwkf');
var BKT_IIOT = "".concat(process.env.BKT_IIOT || 'iiot'); // #endregion
// #region changeConfig Funcs

function changeHZERO_FILE(API_HOST, HZERO_HFLE) {
  return "".concat(API_HOST).concat(HZERO_HFLE);
}
function changeAUTH_HOST(API_HOST, HZERO_OAUTH) {
  return "".concat(API_HOST).concat(HZERO_OAUTH);
}
function changeAUTH_SELF_URL(API_HOST, HZERO_IAM) {
  return "".concat(process.env.AUTH_SELF_URL || "".concat(API_HOST).concat(HZERO_IAM, "/hzero/v1/users/self"));
}
function changeVERSION_IS_OP(PLATFORM_VERSION) {
  return "".concat(PLATFORM_VERSION) === 'OP'; //  OP版
} // #endregion
// #region changeRoute

window.changeRoute = function changeRoute(key, value) {
  if (key && value) {
    switch (key) {
      case 'BPM_HOST':
        BPM_HOST = value;
        break;
      case 'WFP_EDITOR':
        WFP_EDITOR = value;
        break;
      case 'WEBSOCKET_URL':
        WEBSOCKET_URL = value;
        break;
      case 'HISTORY_ENABLE':
        HISTORY_ENABLE = value;
        break;
      case 'SVG_ICON_ENABLE':
        SVG_ICON_ENABLE = value;
        break;
      case 'MULTIPLE_SKIN_ENABLE':
        MULTIPLE_SKIN_ENABLE = value;
        break;
      case 'TOP_MENU_LABELS':
        TOP_MENU_LABELS = value;
        break;
      case 'TOP_MENU_UNION_LABEL':
        TOP_MENU_UNION_LABEL = value;
        break;
      case 'ENV_SIGN':
        ENV_SIGN = value;
        break;
      case 'INVALID_TIME':
        INVALID_TIME = value;
        break;
      case 'CUSTOMIZE_ICON_NAME':
        CUSTOMIZE_ICON_NAME = value;
        break;
      case 'BAIDU_MAP_AK':
        BAIDU_MAP_AK = value;
        break;
      case 'MARKET_CLIENT_SDK_FLAG':
        MARKET_CLIENT_SDK_FLAG = value;
        break;
      case 'HZERO_PLATFORM':
        HZERO_PLATFORM = value;
        break;
      case 'HZERO_IAM':
        HZERO_IAM = value;
        AUTH_SELF_URL = changeAUTH_SELF_URL(API_HOST, value);
        break;
      case 'HZERO_DTT':
        HZERO_DTT = value;
        break;
      case 'HZERO_MSG':
        HZERO_MSG = value;
        break;
      case 'HZERO_PTL':
        HZERO_PTL = value;
        break;
      case 'HZERO_WFL':
        HZERO_WFL = value;
        break;
      case 'HZERO_DTW':
        HZERO_DTW = value;
        break;
      case 'HZERO_HDTW':
        HZERO_HDTW = value;
        break;
      case 'HZERO_SDR':
        HZERO_SDR = value;
        break;
      case 'HZERO_HSGP':
        HZERO_HSGP = value;
        break;
      case 'HZERO_HITF':
        HZERO_HITF = value;
        break;
      case 'HZERO_HFLE':
        HZERO_HFLE = value;
        HZERO_FILE = changeHZERO_FILE(API_HOST, value);
        break;
      case 'HZERO_OAUTH':
        HZERO_OAUTH = value;
        AUTH_HOST = changeAUTH_HOST(API_HOST, value);
        break;
      case 'HZERO_ASGARD':
        HZERO_ASGARD = value;
        break;
      case 'HZERO_IMP':
        HZERO_IMP = value;
        break;
      case 'HZERO_RPT':
        HZERO_RPT = value;
        break;
      case 'HZERO_HCNF':
        HZERO_HCNF = value;
        break;
      case 'HZERO_HWFP':
        HZERO_HWFP = value;
        break;
      case 'HZERO_FILE':
        HZERO_FILE = value;
        break;
      case 'API_HOST':
        HZERO_FILE = changeHZERO_FILE(value, HZERO_HFLE);
        AUTH_HOST = changeAUTH_HOST(value, HZERO_OAUTH);
        AUTH_SELF_URL = changeAUTH_SELF_URL(value, HZERO_IAM);
        break;
      case 'HZERO_NLP':
        HZERO_NLP = value;
        break;
      case 'HZERO_HPAY':
        HZERO_HPAY = value;
        break;
      case 'HZERO_HEXL':
        HZERO_HEXL = value;
        break;
      case 'HZERO_MNT':
        HZERO_MNT = value;
        break;
      case 'HZERO_INVOICE':
        HZERO_INVOICE = value;
        break;
      case 'HZERO_IM':
        HZERO_IM = value;
        break;
      case 'HZERO_OCR':
        HZERO_OCR = value;
        break;
      case 'HZERO_CHG':
        HZERO_CHG = value;
        break;
      case 'HZERO_ADM':
        HZERO_ADM = value;
        break;
      case 'HZERO_DPM':
        HZERO_DPM = value;
        break;
      case 'HZERO_HSRH':
        HZERO_HSRH = value;
        break;
      case 'HZERO_HMDE':
        HZERO_HMDE = value;
        break;
      case 'HZERO_HRES':
        HZERO_HRES = value;
        break;
      case 'HZERO_HLCD':
        HZERO_HLCD = value;
        break;
      case 'HZERO_HLOD':
        HZERO_HLOD = value;
        break;
      case 'HZERO_HIOT':
        HZERO_HIOT = value;
        break;
      case 'IIOT_IPFM':
        IIOT_IPFM = value;
        break;
      case 'HZERO_HEBK':
        HZERO_HEBK = value;
        break;
      case 'HZERO_ALT':
        HZERO_ALT = value;
        break;
      case 'HZERO_HEVT':
        HZERO_HEVT = value;
        break;
      case 'HZERO_HDSC':
        HZERO_HDSC = value;
        break;
      case 'HZERO_HORC':
        HZERO_HORC = value;
        break;
      case 'HZERO_HFNT':
        HZERO_HFNT = value;
        break;
      case 'HZERO_HTDO':
        HZERO_HTDO = value;
        break;
      case 'HZERO_HKMS':
        HZERO_HKMS = value;
        break;
      case 'HZERO_HPRT':
        HZERO_HPRT = value;
        break;
      case 'HZERO_HWKF':
        HZERO_HWKF = value;
        break;
      case 'HZERO_HBAI':
        HZERO_HBAI = value;
        break;
      case 'AUTH_HOST':
        AUTH_HOST = value;
        break;
      case 'LOGIN_URL':
        LOGIN_URL = value;
        break;
      case 'LOGOUT_URL':
        LOGOUT_URL = value;
        break;
      case 'AUTH_SELF_URL':
        AUTH_SELF_URL = value;
        break;
      case 'VERSION_IS_OP':
        VERSION_IS_OP = value;
        break;
      case 'PLATFORM_VERSION':
        VERSION_IS_OP = changeVERSION_IS_OP(value);
        break;
      case 'BKT_PUBLIC':
        BKT_PUBLIC = value;
        break;
      case 'BKT_PLATFORM':
        BKT_PLATFORM = value;
        break;
      case 'BKT_MSG':
        BKT_MSG = value;
        break;
      case 'BKT_SDR':
        BKT_SDR = value;
        break;
      case 'BKT_RPT':
        BKT_RPT = value;
        break;
      case 'BKT_INVOICE':
        BKT_INVOICE = value;
        break;
      case 'BKT_OCR':
        BKT_OCR = value;
        break;
      case 'BKT_ADM':
        BKT_ADM = value;
        break;
      case 'BKT_HWFP':
        BKT_HWFP = value;
        break;
      case 'BKT_HIMS':
        BKT_HIMS = value;
        break;
      case 'BKT_HITF':
        BKT_HITF = value;
        break;
      case 'BKT_HIMP':
        BKT_HIMP = value;
        break;
      case 'BKT_HFILE':
        BKT_HFILE = value;
        break;
      case 'BKT_HIOT':
        BKT_HIOT = value;
        break;
      case 'BKT_IIOT':
        BKT_IIOT = value;
        break;
      case 'BKT_HORC':
        BKT_HORC = value;
        break;
      case 'BKT_HFNT':
        BKT_HFNT = value;
        break;
      case 'BKT_HTDO':
        BKT_HTDO = value;
        break;
      case 'BKT_HWKF':
        BKT_HWKF = value;
        break;
      default:
        console.error("".concat(key, " is not exists"));
        helpMethod();
        break;
    }
  } else {
    helpMethod(key);
  }
}; // #endregion
// #region helpMethod

var helpMethodAssist = {
  BPM_HOST: {
    changeConfig: ['BPM_HOST'],
    depBy: []
  },
  WFP_EDITOR: {
    changeConfig: ['WFP_EDITOR'],
    depBy: []
  },
  WEBSOCKET_URL: {
    changeConfig: ['WEBSOCKET_URL'],
    depBy: []
  },
  HISTORY_ENABLE: {
    changeConfig: ['HISTORY_ENABLE'],
    depBy: []
  },
  SVG_ICON_ENABLE: {
    changeConfig: ['SVG_ICON_ENABLE'],
    depBy: []
  },
  MULTIPLE_SKIN_ENABLE: {
    changeConfig: ['MULTIPLE_SKIN_ENABLE'],
    depBy: []
  },
  TOP_MENU_LABELS: {
    changeConfig: ['TOP_MENU_LABELS'],
    depBy: []
  },
  TOP_MENU_UNION_LABEL: {
    changeConfig: ['TOP_MENU_UNION_LABEL'],
    depBy: []
  },
  INVALID_TIME: {
    changeConfig: ['INVALID_TIME'],
    depBy: []
  },
  CUSTOMIZE_ICON_NAME: {
    changeConfig: ['CUSTOMIZE_ICON_NAME'],
    depBy: []
  },
  BAIDU_MAP_AK: {
    changeConfig: ['BAIDU_MAP_AK'],
    depBy: []
  },
  MARKET_CLIENT_SDK_FLAG: {
    changeConfig: ['MARKET_CLIENT_SDK_FLAG'],
    depBy: []
  },
  HZERO_PLATFORM: {
    changeConfig: ['HZERO_PLATFORM'],
    depBy: []
  },
  HZERO_IAM: {
    changeConfig: ['HZERO_IAM', 'AUTH_SELF_URL'],
    depBy: []
  },
  HZERO_DTT: {
    changeConfig: ['HZERO_DTT'],
    depBy: []
  },
  HZERO_MSG: {
    changeConfig: ['HZERO_MSG'],
    depBy: []
  },
  HZERO_PTL: {
    changeConfig: ['HZERO_PTL'],
    depBy: []
  },
  HZERO_WFL: {
    changeConfig: ['HZERO_WFL'],
    depBy: []
  },
  HZERO_DTW: {
    changeConfig: ['HZERO_DTW'],
    depBy: []
  },
  HZERO_HDTW: {
    changeConfig: ['HZERO_HDTW'],
    depBy: []
  },
  HZERO_SDR: {
    changeConfig: ['HZERO_SDR'],
    depBy: []
  },
  HZERO_HSGP: {
    changeConfig: ['HZERO_HSGP'],
    depBy: []
  },
  HZERO_HITF: {
    changeConfig: ['HZERO_HITF'],
    depBy: []
  },
  HZERO_HFLE: {
    changeConfig: ['HZERO_HFLE', 'HZERO_FILE'],
    depBy: []
  },
  HZERO_OAUTH: {
    changeConfig: ['HZERO_OAUTH', 'AUTH_HOST'],
    depBy: []
  },
  HZERO_ASGARD: {
    changeConfig: ['HZERO_ASGARD'],
    depBy: []
  },
  HZERO_IMP: {
    changeConfig: ['HZERO_IMP'],
    depBy: []
  },
  HZERO_RPT: {
    changeConfig: ['HZERO_RPT'],
    depBy: []
  },
  HZERO_HCNF: {
    changeConfig: ['HZERO_HCNF'],
    depBy: []
  },
  HZERO_HWFP: {
    changeConfig: ['HZERO_HWFP'],
    depBy: []
  },
  HZERO_FILE: {
    changeConfig: ['HZERO_FILE'],
    depBy: ['HZERO_FILE', 'HZERO_FILE']
  },
  API_HOST: {
    changeConfig: ['HZERO_FILE', 'AUTH_HOST', 'AUTH_SELF_URL'],
    depBy: []
  },
  HZERO_NLP: {
    changeConfig: ['HZERO_NLP'],
    depBy: []
  },
  HZERO_HPAY: {
    changeConfig: ['HZERO_HPAY'],
    depBy: []
  },
  HZERO_HEXL: {
    changeConfig: ['HZERO_HEXL'],
    depBy: []
  },
  HZERO_MNT: {
    changeConfig: ['HZERO_MNT'],
    depBy: []
  },
  HZERO_INVOICE: {
    changeConfig: ['HZERO_INVOICE'],
    depBy: []
  },
  HZERO_IM: {
    changeConfig: ['HZERO_IM'],
    depBy: []
  },
  HZERO_OCR: {
    changeConfig: ['HZERO_OCR'],
    depBy: []
  },
  HZERO_CHG: {
    changeConfig: ['HZERO_CHG'],
    depBy: []
  },
  HZERO_ADM: {
    changeConfig: ['HZERO_ADM'],
    depBy: []
  },
  HZERO_DPM: {
    changeConfig: ['HZERO_DPM'],
    depBy: []
  },
  HZERO_HSRH: {
    changeConfig: ['HZERO_HSRH'],
    depBy: []
  },
  HZERO_HMDE: {
    changeConfig: ['HZERO_HMDE'],
    depBy: []
  },
  HZERO_HRES: {
    changeConfig: ['HZERO_HRES'],
    depBy: []
  },
  HZERO_HLCD: {
    changeConfig: ['HZERO_HLCD'],
    depBy: []
  },
  HZERO_HLOD: {
    changeConfig: ['HZERO_HLOD'],
    depBy: []
  },
  HZERO_HIOT: {
    changeConfig: ['HZERO_HIOT'],
    depBy: []
  },
  IIOT_IPFM: {
    changeConfig: ['IIOT_IPFM'],
    depBy: []
  },
  HZERO_HEBK: {
    changeConfig: ['HZERO_HEBK'],
    depBy: []
  },
  HZERO_ALT: {
    changeConfig: ['HZERO_ALT'],
    depBy: []
  },
  HZERO_EVENT: {
    changeConfig: ['HZERO_EVENT'],
    depBy: []
  },
  HZERO_HORC: {
    changeConfig: ['HZERO_HORC'],
    depBy: []
  },
  HZERO_HFNT: {
    changeConfig: ['HZERO_HFNT'],
    depBy: []
  },
  HZERO_HTDO: {
    changeConfig: ['HZERO_HTDO'],
    depBy: []
  },
  HZERO_HKMS: {
    changeConfig: ['HZERO_HKMS'],
    depBy: []
  },
  HZERO_HPRT: {
    changeConfig: ['HZERO_HPRT'],
    depBy: []
  },
  HZERO_HWKF: {
    changeConfig: ['HZERO_HWKF'],
    depBy: []
  },
  HZERO_HBAI: {
    changeConfig: ['HZERO_HBAI'],
    depBy: []
  },
  AUTH_HOST: {
    changeConfig: ['AUTH_HOST'],
    depBy: ['AUTH_HOST', 'AUTH_HOST']
  },
  LOGIN_URL: {
    changeConfig: ['LOGIN_URL'],
    depBy: []
  },
  LOGOUT_URL: {
    changeConfig: ['LOGOUT_URL'],
    depBy: []
  },
  AUTH_SELF_URL: {
    changeConfig: ['AUTH_SELF_URL'],
    depBy: ['AUTH_SELF_URL', 'AUTH_SELF_URL']
  },
  VERSION_IS_OP: {
    changeConfig: ['VERSION_IS_OP'],
    depBy: ['VERSION_IS_OP']
  },
  PLATFORM_VERSION: {
    changeConfig: ['VERSION_IS_OP'],
    depBy: []
  },
  BKT_PUBLIC: {
    changeConfig: ['BKT_PUBLIC'],
    depBy: []
  },
  BKT_PLATFORM: {
    changeConfig: ['BKT_PLATFORM'],
    depBy: []
  },
  BKT_MSG: {
    changeConfig: ['BKT_MSG'],
    depBy: []
  },
  BKT_SDR: {
    changeConfig: ['BKT_SDR'],
    depBy: []
  },
  BKT_RPT: {
    changeConfig: ['BKT_RPT'],
    depBy: []
  },
  BKT_INVOICE: {
    changeConfig: ['BKT_INVOICE'],
    depBy: []
  },
  BKT_OCR: {
    changeConfig: ['BKT_OCR'],
    depBy: []
  },
  BKT_ADM: {
    changeConfig: ['BKT_ADM'],
    depBy: []
  },
  BKT_HWFP: {
    changeConfig: ['BKT_HWFP'],
    depBy: []
  },
  BKT_HIMS: {
    changeConfig: ['BKT_HIMS'],
    depBy: []
  },
  BKT_HITF: {
    changeConfig: ['BKT_HITF'],
    depBy: []
  },
  BKT_HIMP: {
    changeConfig: ['BKT_HIMP'],
    depBy: []
  },
  BKT_HFILE: {
    changeConfig: ['BKT_HFILE'],
    depBy: []
  },
  BKT_HIOT: {
    changeConfig: ['BKT_HIOT'],
    depBy: []
  },
  BKT_IIOT: {
    changeConfig: ['BKT_IIOT'],
    depBy: []
  },
  BKT_HORC: {
    changeConfig: ['BKT_HORC'],
    depBy: []
  },
  BKT_HFNT: {
    changeConfig: ['BKT_HFNT'],
    depBy: []
  },
  BKT_HTDO: {
    changeConfig: ['BKT_HTDO'],
    depBy: []
  },
  BKT_HWKF: {
    changeConfig: ['BKT_HWKF'],
    depBy: []
  }
};
function helpMethod(key) {
  if (key && helpMethodAssist[key]) {
    console.error("".concat(key, " \u4F1A\u66F4\u6539: [").concat(helpMethodAssist[key].changeConfig.join(', '), "], \u88AB\u7EA7\u8FDE\u66F4\u6539: [").concat(helpMethodAssist[key].depBy.join(', '), "]"));
  } else {
    console.error('使用 changeRoute() 查看可以更改的参数');
    console.error('使用 changeRoute("参数") 查看具体改变');
    console.error('使用 changeRoute("参数", "参数值") 更改参数');
    console.error("\u53EF\u4EE5\u66F4\u6539\u7684\u914D\u7F6E: [".concat(Object.keys(helpMethodAssist).join(', '), "]"));
  }
} // #endregion
// #regioin exportsConfig

export { CLIENT_ID, API_HOST, BPM_HOST, WFP_EDITOR, WEBSOCKET_URL, HISTORY_ENABLE, SVG_ICON_ENABLE, MULTIPLE_SKIN_ENABLE, TOP_MENU_LABELS, TOP_MENU_UNION_LABEL, ENV_SIGN, INVALID_TIME, CUSTOMIZE_ICON_NAME, BAIDU_MAP_AK, MARKET_CLIENT_SDK_FLAG, HZERO_PLATFORM, HZERO_IAM, HZERO_DTT, HZERO_MSG, HZERO_PTL, HZERO_WFL, HZERO_DTW, HZERO_HDTW, HZERO_SDR, HZERO_HSGP, HZERO_HITF, HZERO_HFLE, HZERO_OAUTH, HZERO_ASGARD, HZERO_IMP, HZERO_RPT, HZERO_HCNF, HZERO_HWFP, HZERO_FILE, HZERO_NLP, HZERO_HPAY, HZERO_HEXL, HZERO_MNT, HZERO_INVOICE, HZERO_IM, HZERO_OCR, HZERO_CHG, HZERO_ADM, HZERO_DPM, HZERO_HSRH, HZERO_HMDE, HZERO_HRES, HZERO_HLCD, HZERO_HLOD, HZERO_HIOT, IIOT_IPFM, HZERO_HEBK, HZERO_ALT, HZERO_HEVT, HZERO_HDSC, HZERO_HORC, HZERO_HFNT, HZERO_HTDO, HZERO_HKMS, HZERO_HPRT, HZERO_HWKF, HZERO_HBAI, AUTH_HOST, LOGIN_URL, LOGOUT_URL, AUTH_SELF_URL, VERSION_IS_OP, BKT_PUBLIC, BKT_PLATFORM, BKT_MSG, BKT_SDR, BKT_RPT, BKT_INVOICE, BKT_OCR, BKT_ADM, BKT_HWFP, BKT_HIMS, BKT_HITF, BKT_HIMP, BKT_HFILE, BKT_HIOT, BKT_IIOT, BKT_HORC, BKT_HFNT, BKT_HTDO, BKT_HWKF }; // #endregion